import PropTypes from 'prop-types';

export const formFieldPropTypes = PropTypes.shape({
  value: PropTypes.string,
  message: PropTypes.string,
  valid: PropTypes.bool,
});

export const formFieldDefaultProp = PropTypes.shape({
  value: '',
  message: '',
  valid: true,
});
